module.exports = __webpack_public_path__ + "static/media/analitic-man.53279ee1.png";